import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import fast from '../assets/images/fast.png';
import adamjee from '../assets/images/adamjee.png';
import usman from '../assets/images/usman.jpg';

function Education() {
  return (
    <div id="academia">
      <div className="items-container">
        <h1>Academic Background</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2020 - 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img style={{ marginRight: '5px' }} src={fast} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">FAST - NUCES</h2>
            </div>
            <h4>
              B.Sc. in Computer Science
              <span style={{ margin: '.5rem', fontSize: '12px' }}><i>(3.64/4 CGPA)</i></span>
            </h4>            <p>
              Courses Studied:
            </p>
            <ul>
              <li>Agile Software Project Management</li>
              <li>Data Structures</li>
              <li>Database</li>
              <li>Design and Analysis of Algorithms</li>
              <li>Design Defects and Restructuring</li>
              <li>DevOps</li>
              <li>Object Oriented Programming</li>
              <li>Operating Systems</li>
              <li>Software and Requirement Engineering</li>
              <li>Software Development and Analysis</li>
            </ul>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2018 - 2020"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img style={{ marginRight: '5px' }} src={adamjee} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">Adamjee Government Science College</h2>
            </div>
            <h4>Intermediate in Pre-Engineering              <span style={{ margin: '.5rem', fontSize: '12px' }}><i>(A+ Grade)</i></span>
            </h4>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2016 - 2018"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img style={{ marginRight: '5px' }} src={usman} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">Usman Public School System</h2>
            </div>
            <h4>Matriculation in Science              <span style={{ margin: '.5rem', fontSize: '12px' }}><i>(A+ Grade)</i></span>
            </h4>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Education;